module.exports = __webpack_public_path__ + "img/plans-and-prices.0282d76a.png";